import MyMeeting from './MyMeeting.vue'//我的会议
import Qiandaobiao from './Qiandaobiao.vue'//会议统计
import MeetingGroup from './MeetingGroup.vue'//会议组
import scheduleMeeting from './scheduleMeeting.vue' // 预定会议
import MeetingRoom from './MeetingRoom.vue'//会议室
import MeetingSign from './MeetingSign.vue'//会议签到
import MeetingProcess from './MeetingProcess.vue'//会议审核
import * as operate from './operate'

let a = Object.assign({ MyMeeting, Qiandaobiao, MeetingGroup, scheduleMeeting, MeetingRoom, MeetingProcess, MeetingSign }, operate)
export default a
